import { useState, type FormEvent } from "react";
import { LanguageSwitcher } from "../LanguageSwitcher";
import { submitPublicLead } from "../../lib/publicLead";
import type { SupportedLocale } from "../../lib/localization";
import { SITE_LOGO } from "./SiteNav";

type FooterColumn = { title: string; links: Array<{ label: string; href: string; soon?: boolean }> };

export const SOCIAL_ICONS: Record<string, string> = {
  LinkedIn:
    "M18.5195 0H1.47656C0.660156 0 0 0.644531 0 1.44141V18.5547C0 19.3516 0.660156 20 1.47656 20H18.5195C19.3359 20 20 19.3516 20 18.5586V1.44141C20 0.644531 19.3359 0 18.5195 0ZM5.93359 17.043H2.96484V7.49609H5.93359V17.043ZM4.44922 6.19531C3.49609 6.19531 2.72656 5.42578 2.72656 4.47656C2.72656 3.52734 3.49609 2.75781 4.44922 2.75781C5.39844 2.75781 6.16797 3.52734 6.16797 4.47656C6.16797 5.42187 5.39844 6.19531 4.44922 6.19531ZM17.043 17.043H14.0781V12.4023C14.0781 11.2969 14.0586 9.87109 12.5352 9.87109C10.9922 9.87109 10.7578 11.0781 10.7578 12.3242V17.043H7.79688V7.49609H10.6406V8.80078H10.6797C11.0742 8.05078 12.043 7.25781 13.4844 7.25781C16.4883 7.25781 17.043 9.23438 17.043 11.8047V17.043V17.043Z",
  Facebook:
    "M20 10.0611C20 4.50451 15.5229 0 10 0C4.47715 0 0 4.50451 0 10.0611C0 15.0828 3.65684 19.2452 8.4375 20V12.9694H5.89844V10.0611H8.4375V7.84452C8.4375 5.32296 9.93047 3.93012 12.2146 3.93012C13.3084 3.93012 14.4531 4.12663 14.4531 4.12663V6.60261H13.1922C11.95 6.60261 11.5625 7.37822 11.5625 8.17465V10.0611H14.3359L13.8926 12.9694H11.5625V20C16.3432 19.2452 20 15.0828 20 10.0611Z",
  Instagram:
    "M10 1.80078C12.6719 1.80078 12.9883 1.8125 14.0391 1.85937C15.0156 1.90234 15.543 2.06641 15.8945 2.20313C16.3594 2.38281 16.6953 2.60156 17.043 2.94922C17.3945 3.30078 17.6094 3.63281 17.7891 4.09766C17.9258 4.44922 18.0898 4.98047 18.1328 5.95312C18.1797 7.00781 18.1914 7.32422 18.1914 9.99219C18.1914 12.6641 18.1797 12.9805 18.1328 14.0313C18.0898 15.0078 17.9258 15.5352 17.7891 15.8867C17.6094 16.3516 17.3906 16.6875 17.043 17.0352C16.6914 17.3867 16.3594 17.6016 15.8945 17.7813C15.543 17.918 15.0117 18.082 14.0391 18.125C12.9844 18.1719 12.668 18.1836 10 18.1836C7.32813 18.1836 7.01172 18.1719 5.96094 18.125C4.98438 18.082 4.45703 17.918 4.10547 17.7813C3.64063 17.6016 3.30469 17.3828 2.95703 17.0352C2.60547 16.6836 2.39063 16.3516 2.21094 15.8867C2.07422 15.5352 1.91016 15.0039 1.86719 14.0313C1.82031 12.9766 1.80859 12.6602 1.80859 9.99219C1.80859 7.32031 1.82031 7.00391 1.86719 5.95312C1.91016 4.97656 2.07422 4.44922 2.21094 4.09766C2.39063 3.63281 2.60938 3.29688 2.95703 2.94922C3.30859 2.59766 3.64063 2.38281 4.10547 2.20313C4.45703 2.06641 4.98828 1.90234 5.96094 1.85937C7.01172 1.8125 7.32813 1.80078 10 1.80078ZM10 0C7.28516 0 6.94531 0.0117188 5.87891 0.0585938C4.81641 0.105469 4.08594 0.277344 3.45313 0.523438C2.79297 0.78125 2.23438 1.12109 1.67969 1.67969C1.12109 2.23438 0.78125 2.79297 0.523438 3.44922C0.277344 4.08594 0.105469 4.8125 0.0585938 5.875C0.0117188 6.94531 0 7.28516 0 10C0 12.7148 0.0117188 13.0547 0.0585938 14.1211C0.105469 15.1836 0.277344 15.9141 0.523438 16.5469C0.78125 17.207 1.12109 17.7656 1.67969 18.3203C2.23438 18.875 2.79297 19.2188 3.44922 19.4727C4.08594 19.7188 4.8125 19.8906 5.875 19.9375C6.94141 19.9844 7.28125 19.9961 9.99609 19.9961C12.7109 19.9961 13.0508 19.9844 14.1172 19.9375C15.1797 19.8906 15.9102 19.7188 16.543 19.4727C17.1992 19.2188 17.7578 18.875 18.3125 18.3203C18.8672 17.7656 19.2109 17.207 19.4648 16.5508C19.7109 15.9141 19.8828 15.1875 19.9297 14.125C19.9766 13.0586 19.9883 12.7188 19.9883 10.0039C19.9883 7.28906 19.9766 6.94922 19.9297 5.88281C19.8828 4.82031 19.7109 4.08984 19.4648 3.45703C19.2188 2.79297 18.8789 2.23438 18.3203 1.67969C17.7656 1.125 17.207 0.78125 16.5508 0.527344C15.9141 0.28125 15.1875 0.109375 14.125 0.0625C13.0547 0.0117188 12.7148 0 10 0ZM10 4.86328C7.16406 4.86328 4.86328 7.16406 4.86328 10C4.86328 12.8359 7.16406 15.1367 10 15.1367C12.8359 15.1367 15.1367 12.8359 15.1367 10C15.1367 7.16406 12.8359 4.86328 10 4.86328ZM10 13.332C8.16016 13.332 6.66797 11.8398 6.66797 10C6.66797 8.16016 8.16016 6.66797 10 6.66797C11.8398 6.66797 13.332 8.16016 13.332 10C13.332 11.8398 11.8398 13.332 10 13.332ZM16.5391 4.66016C16.5391 5.32422 16 5.85938 15.3398 5.85938C14.6758 5.85938 14.1406 5.32031 14.1406 4.66016C14.1406 3.99609 14.6797 3.46094 15.3398 3.46094C16.0039 3.46094 16.5391 4 16.5391 4.66016Z",
};

export function SiteFooter({
  logo,
  tagline,
  copyright,
  socials,
  columns,
  newsletter,
  locale,
  onLocaleChange,
  onNavigate,
}: {
  logo?: string;
  tagline: string;
  copyright: string;
  socials: Array<{ name: string; href: string }>;
  columns: FooterColumn[];
  newsletter: { title: string; text: string; label: string; button: string };
  locale: SupportedLocale;
  onLocaleChange?: (locale: SupportedLocale) => void;
  onNavigate: (href: string) => void;
}) {
  const [status, setStatus] = useState<"idle" | "sending" | "done" | "error">("idle");

  const subscribe = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const email = String(new FormData(event.currentTarget).get("email") || "").trim();
    if (!email) return;
    setStatus("sending");
    try {
      await submitPublicLead({
        name: email,
        email,
        message: "Newsletter signup (Get notified)",
        source: "website",
        locale,
      });
      setStatus("done");
    } catch {
      setStatus("error");
    }
  };

  return (
    <footer className="relative overflow-hidden pt-[73px] min-[810px]:pt-24 min-[1200px]:pt-[105px]">
      <div className="site-container">
        <div className="flex flex-col gap-[53px] min-[810px]:gap-12 min-[1200px]:flex-row min-[1200px]:justify-between">
          <div className="flex flex-col gap-6 min-[1200px]:w-[320px] min-[1200px]:gap-4">
            <img src={logo || SITE_LOGO} alt="ON45D Studio" className="h-[38px] w-fit" />
            {tagline ? (
              <p className="text-[16px] font-medium leading-[1.5] text-[#A3A3A3]">{tagline}</p>
            ) : null}
            <div className="flex gap-5 min-[810px]:gap-4">
              {socials.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                  className="text-[#737373] transition-colors hover:text-white"
                >
                  <svg viewBox="0 0 20 20" className="h-[33px] w-[33px] min-[810px]:h-[30px] min-[810px]:w-[30px] min-[1200px]:h-5 min-[1200px]:w-5" aria-hidden="true">
                    <path d={SOCIAL_ICONS[social.name]} fill="currentColor" />
                  </svg>
                </a>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-[33px] min-[810px]:grid min-[810px]:grid-cols-2 min-[810px]:gap-x-8 min-[810px]:gap-y-12 min-[1200px]:flex min-[1200px]:flex-row min-[1200px]:gap-0">
            {columns.map((column, index) => (
              <div key={column.title} className={index === 0 ? "min-[1200px]:w-[204px]" : "min-[1200px]:w-[172px]"}>
                <p className="text-[16px] font-semibold leading-[1.5] text-[#E5E5E5]">{column.title}</p>
                <ul className="mt-3 flex flex-col gap-[17px] min-[810px]:mt-4 min-[810px]:gap-6 min-[1200px]:gap-3">
                  {column.links.map((link) => (
                    <li key={link.label} className="flex items-center gap-[6px]">
                      <a
                        href={link.href}
                        className="text-[16px] font-semibold leading-[1.2] tracking-[0.02em] text-[#A3A3A3] transition-colors hover:text-white"
                        onClick={(event) => {
                          if (link.href.startsWith("#")) {
                            event.preventDefault();
                            onNavigate(link.href);
                          }
                        }}
                      >
                        {link.label}
                      </a>
                      {link.soon ? (
                        <span className="rounded-md bg-[#0A0A0A] px-[6px] py-[2px] ring-1 ring-inset ring-white/15 font-['Inter'] text-[12px] font-medium leading-[18px] text-[#D4D4D4]">
                          Soon
                        </span>
                      ) : null}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div className="min-[810px]:col-span-2 min-[1200px]:w-[349px]">
              <p className="text-[16px] font-semibold leading-[1.5] text-[#E5E5E5]">{newsletter.title}</p>
              <p className="mt-4 text-[16px] font-medium leading-[1.5] text-[#A3A3A3]">{newsletter.text}</p>
              <form className="mt-6" onSubmit={subscribe}>
                <label htmlFor="site-newsletter" className="text-[15px] font-medium leading-[1.5] text-[#A3A3A3]">
                  {newsletter.label}
                </label>
                <div className="mt-[6px] flex gap-3">
                  <input
                    id="site-newsletter"
                    name="email"
                    type="email"
                    required
                    placeholder="jane@gmail.com"
                    className="h-[42px] min-w-0 flex-1 rounded-[10px] bg-[rgba(187,187,187,0.15)] px-3 text-[15px] text-white placeholder:text-[#A3A3A3] focus:outline-none focus:ring-1 focus:ring-[var(--public-accent)]"
                  />
                  <button
                    type="submit"
                    disabled={status === "sending" || status === "done"}
                    className="h-[42px] shrink-0 rounded-[10px] bg-[var(--public-accent)] px-[19px] text-[18px] font-semibold text-[var(--public-cta-ink)] disabled:opacity-70"
                  >
                    {status === "done" ? "✓" : newsletter.button}
                  </button>
                </div>
                {status === "error" ? <p className="mt-2 text-[13px] text-red-300">Error</p> : null}
              </form>
            </div>
          </div>
        </div>
        <div className="mt-[60px] flex items-center justify-between gap-4 border-t border-white/10 pt-6 min-[810px]:mt-[63px]">
          <p className="text-[14px] font-medium leading-[20px] text-[#A3A3A3]">{copyright}</p>
          {onLocaleChange ? (
            <div className="hidden min-[810px]:block">
              <LanguageSwitcher locale={locale} onChange={onLocaleChange} />
            </div>
          ) : null}
        </div>
        <img src="/site/footer-wordmark.png" alt="" className="mt-0 w-full" loading="lazy" />
      </div>
    </footer>
  );
}
